/* global document, HTMLSelectElement */

import { getInputValue } from '../../shared/dom.util';
import type { ReportingTargetFilterDefinition } from '../reporting-target/reporting-target-filter.types';

/** Task pane `<select id="…">` for record type / agreement type (matches `taskpane.html`). */
export const FILTER_RECORD_TYPE_ELEMENT_ID = 'filter-record-type';

const REPORT_RECORD_TYPE_FIELD_WRAP_ID = 'report-record-type-field';

function optionValues(
    spec: NonNullable<ReportingTargetFilterDefinition['recordTypeFilter']>
): Set<string> {
    return new Set(spec.options.map((o) => o.value));
}

/**
 * Fills the Record type `<select>` from the current reporting target definition and toggles visibility.
 * Call whenever the target changes or panels re-render.
 */
export function syncRecordTypeFieldForReportingTarget(
    definition: ReportingTargetFilterDefinition
): void {
    const wrap = document.getElementById(REPORT_RECORD_TYPE_FIELD_WRAP_ID);
    const sel = document.getElementById(FILTER_RECORD_TYPE_ELEMENT_ID) as HTMLSelectElement | null;
    if (!wrap || !sel) {
        return;
    }

    const spec = definition.recordTypeFilter;
    if (!spec) {
        wrap.classList.add('hidden');
        return;
    }

    wrap.classList.remove('hidden');
    const previous = getInputValue(FILTER_RECORD_TYPE_ELEMENT_ID);
    sel.replaceChildren();
    for (const opt of spec.options) {
        const optionEl = document.createElement('option');
        optionEl.value = opt.value;
        optionEl.textContent = opt.label;
        sel.append(optionEl);
    }

    const allowed = optionValues(spec);
    sel.value = allowed.has(previous) ? previous : spec.defaultValue;
}
